import React from "react";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  return (
    <nav className="navbar  p-0 pl-3 pr-5 fixed-top bg-white d-flex flex-row">
      <div className="container-fluid">
        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
          <a className="navbar-brand brand-logo mr-1" href="/dashboard">
            KSPD Admission
          </a>
          <a className="navbar-brand brand-logo-mini" href="/dashboard">
            KSPD
          </a>
        </div>
        
        <ul className="nav navbar-nav d-flex flex-row ">
          <li className="nav-item pr-4 pointer" onClick={() => navigate("/app/dashboard")}>
            <i className="fa fa-home text-primary"></i> Dashboard
          </li>
          <li className="nav-item pointer" onClick={() => navigate("/")}>
            <i className="fa fa-power-off text-danger"></i> Sign Out
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
